<template>
    <el-dialog
        :before-close="onClose"
        :visible.sync="visible"
        center
        title="Thêm mới nhân sự coi thi, chấm thi"
        width="900px"
    >
        <el-form ref="form" :model="form" :rules="rules" label-position="top" label-width="140px" >
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Tìm nhân sự <span class="text-danger">*</span></label>
                        <el-form-item  prop="user_id">
                            <el-select
                                ref="new_student"
                                v-model="form.user_id"
                                :loading="loading"
                                :remote-method="remoteMethod"
                                class="w-100"
                                clearable
                                filterable
                                placeholder="Nhập mã học viên, số điện thoại, tên học viên"
                                remote
                                reserve-keyword
                                @change="handleSelectUser"
                            >
                                <el-option
                                    v-for="user in userSearch"
                                    :key="user.id"
                                    :label="user.id + 100000 + ' - ' + user.name"
                                    :value="user.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Loại nhân sự <span class="text-danger">*</span></label>
                        <el-form-item  prop="type_id">
                            <el-select
                                v-model="form.type_id"
                                class="w-100"
                                clearable
                                filterable
                                placeholder="Chọn loại nhân sự"
                            >
                                <el-option
                                    v-for="item in typeOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Hình thức làm việc <span class="text-danger">*</span></label>
                        <el-form-item  prop="type_work_id">
                            <el-select
                                v-model="form.type_work_id"
                                class="w-100"
                                clearable
                                filterable
                                placeholder="Chọn hình thức làm việc"
                                :disabled="isWorkTypeLocked"
                            >
                                <el-option
                                    v-for="item in workTypeOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
                <div v-if="form.type_work_id === offlineOptions" class="col-md-6">
                    <div class="form-group">
                        <label
                        >Cơ sở trực test offline<span class="text-danger">*</span></label
                        >
                      <el-form-item  prop="branch_id">
                        <el-select
                            v-model="form.branch_id"
                            class="w-100"
                            clearable
                            filterable
                            placeholder="Chọn văn phòng trực offline"
                        >
                            <el-option
                                v-for="item in branches"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                      </el-form-item>
                    </div>
                </div>
              <div class="col-md-6" v-if="form.type_work_id === onlineOptions && form.type_id !== 1">
                <div class="form-group">
                  <label>Link Zoom<span class="text-danger">*</span></label>
                  <el-form-item  prop="link_test">
                  <el-input v-model="form.link_test" style="width: 100%" placeholder="Nhập link zoom" />
                  </el-form-item>
                </div>
              </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <el-form-item class="mb-0">
                            <el-switch
                                v-model="form.status"
                                :active-value="1"
                                :inactive-value="0"
                                active-text="Hiển thị"
                                inactive-text="Ẩn"
                            />
                        </el-form-item>
                    </div>
                </div>

            </div>
            <div class="d-flex justify-content-end mt-4">
                <el-button @click="onClose">Hủy bỏ</el-button>
                <button @click="onSubmit" :disabled="loading" class="ml-2 btn btn-primary" type="button">
                    <span v-if="loading" class="spinner-border spinner-border-sm mr-1" ></span> Xác nhận
                </button>
            </div>
        </el-form>
    </el-dialog>
</template>

<script>
import {ADMIN_PROFILE_TYPE, OFFLINE, ONLINE, WORK_TYPE,ENTRANCE_EXAM_MARKING} from "@/core/option/adminProfile";
import {SEARCH_CUSTOMER_BY_OR_ID} from "@/core/services/store/user/users.module";
import {CREATE_MARKING_ADMIN} from "@/core/services/store/marking/admin.module";

export default {
    name: "AdminCreateModal",
    props: {
        visible: Boolean,
        editData: Object,
        branches: Array,
    },
    data() {
        return {
            typeOptions: ADMIN_PROFILE_TYPE,
            workTypeOptions: WORK_TYPE,
            offlineOptions: OFFLINE,
            onlineOptions: ONLINE,
            form: {
                user_id: "",
                type_id: "",
                type_work_id: "",
                is_fixed_schedule: 1,
                link_test: "",
                mark_level: "",
                branch_id: "",
                status: 1,
                fixed: true,
                schedule: Array(6)
                    .fill()
                    .map(() => Array(7).fill(false)),
            },
            rules: {
                user_id: [
                    {
                        required: true,
                        message: "Vui lòng chọn nhân sự",
                        trigger: "change",
                    },
                ],
                type_id: [
                    {
                        required: true,
                        message: "Vui lòng chọn loại nhân sự",
                        trigger: "change",
                    },
                ],
                type_work_id: [
                    {
                        required: true,
                        message: "Vui lòng chọn hình thức làm việc",
                        trigger: "change",
                    },
                ],
              branch_id: [
                {
                  required: true,
                  message: "Vui lòng cơ sở trực test offline",
                  trigger: "change",
                },
              ],
              link_test: [
                {
                  required: true,
                  message: "Vui lòng thêm link zoom",
                  trigger: "change",
                },
              ],
            },
            days: ["Thứ 2", "Thứ 3", "Thứ 4", "Thứ 5", "Thứ 6", "Thứ 7", "Chủ nhật"],
            shifts: [
                {label: "Sáng 1", value: "morning1", time: "06:15 - 09:00"},
                {label: "Sáng", value: "morning", time: "09:00 - 12:00"},
                {label: "Chiều 1", value: "afternoon1", time: "13:15 - 14:30"},
                {label: "Chiều", value: "afternoon", time: "14:30 - 17:30"},
                {label: "Tối", value: "evening", time: "18:00 - 21:00"},
                {label: "Tối 2", value: "evening2", time: "21:00 - 22:00"},
            ],
            allChecked: Array(6).fill(false),
            loading: false,
            userSearch: [],
        };
    },
    computed: {
        isWorkTypeLocked() {
            return Number(this.form.type_id) === ENTRANCE_EXAM_MARKING;
        },
    },
    watch: {
        "form.type_id"(val) {
            if (Number(val) === ENTRANCE_EXAM_MARKING) {
                this.applyEntranceExamWorkTypeRules();
            }
        },
    },
    methods: {
        applyEntranceExamWorkTypeRules() {
            this.form.type_work_id = ONLINE;
            this.form.branch_id = "";
        },
        async handleSelectUser() {
        },
        remoteMethod: function (query) {
            if (query !== "") {
                this.new_phone = query;
                const params = {
                    search_customer_by_phoneOrId: query,
                    limit: 10000,
                    status: 1,
                    is_staff: 0,
                };
                this.loading = true;
                let vm = this;
                setTimeout(function () {
                    vm.getStudents(params);
                }, 300);
            }
        },
        getStudents(params) {
            this.$store.dispatch(SEARCH_CUSTOMER_BY_OR_ID, params).then((res) => {
                this.userSearch = res.data.data;
                this.loading = false;
            });
        },
        toggleAllDay(shiftIdx) {
            const checked = this.allChecked[shiftIdx];
            this.form.schedule[shiftIdx] = this.form.schedule[shiftIdx].map(
                () => checked
            );
        },
        onDayChange(shiftIdx) {
            // Nếu bỏ tick 1 ngày bất kỳ thì allChecked phải bỏ tick
            this.allChecked[shiftIdx] = this.form.schedule[shiftIdx].every(Boolean);
        },
        onClose() {
          this.form.user_id = "";
          this.form.type_id = "";
          this.form.type_work_id = "";
          this.form.is_fixed_schedule = 1;
          this.form.link_test = "";
          this.form.mark_level = "";
          this.form.branch_id = "";
          this.form.status = 1;
          this.form.fixed = true;
          this.form.schedule = Array(6)
              .fill()
              .map(() => Array(7).fill(false));
            this.$emit("close");
        },
        async onSubmit() {
            this.$refs.form.validate(async (valid) => {
                if (!valid) return;
                this.loading = true;
                try {
                    await this.$store.dispatch(CREATE_MARKING_ADMIN, this.form);
                    this.$message.success("Tạo nhân sự admin thành công!");
                    this.$emit("success");
                    this.onClose();
                } catch (e) {
                    this.$message.error("Có lỗi xảy ra!");
                } finally {
                    this.loading = false;
                }
            });
        },
    },
};
</script>

<style scoped>
.table th,
.table td {
    vertical-align: middle !important;
}

.table th.text-left,
.table td.text-left {
    text-align: left !important;
}
</style>
